import { useContext } from 'react'

import { PageContext } from '@contexts/page-context'

/**
 * Hook to access the page information from the page context.
 *
 * @returns Page information
 */
export const usePageInfo = () => useContext(PageContext)
